import React from 'react';
import PropTypes from 'prop-types';

export default function SuperTitleHeader({ title, superTitle, rightPadding }) {
  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          borderTop: 'solid 1px rgba(0,0,0,0.5)',
          height: 1,
          position: 'absolute',
          top: '-0.5rem',
          left: 0,
          right: rightPadding,
          zIndex: 10,
        }}
      />

      {superTitle && (
        <div
          style={{
            marginTop: 0,
            position: 'absolute',
            top: '-2rem',
            left: 0,
            zIndex: 10,
          }}
        >
          {superTitle}
        </div>
      )}

      <div style={{ marginTop: 0 }}>{title}</div>
    </div>
  );
}

SuperTitleHeader.propTypes = {
  title: PropTypes.string.isRequired,
  superTitle: PropTypes.string,
  rightPadding: PropTypes.number,
};

SuperTitleHeader.defaultProps = {
  superTitle: null,
  rightPadding: 0,
};
